import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';
import { MemberPreferenceType } from '../../../common/enums/member-preference.enum';
import { Language } from '../../../shared/components/ILanguage';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { Country } from '../../../shared/interface/country.interface';
import { Member } from '../../../shared/interface/member.interface';
import { State } from '../../../shared/interface/state.interface';
import { StoreConfig } from '../../../shared/interface/StoreConfig.interface';
import { CacheService } from '../../../shared/services/cache.service';
import { IsoCodeThree } from '../../common/constants';
import { OrderType } from '../../common/enumerations';
import { ResponseStatus } from '../../constants/response-status-constants';
import { MemeberCommunicationPreferenceValue } from '../../enums/member-communication-preference-value.enum';
import { SponsorSearchCriteria } from '../../enums/sponsor-search-criteria.enum';
import { SponsorSearchOption } from '../../enums/sponsor-search-option.enum';
import { SponsorWizardSearchType } from '../../enums/sponsor-wizard-type.enum';
import { Address } from '../../interface/address';
import {
  MemberCommunicationPreference, SponsorInformation, SponsorSearchRequest, SponsorSearchResponse,
  ZipCodePattern
} from '../../interface/enrollment';
import { RebindSponsorData } from '../../interface/enrollment/sponsor-rebind-data.interface';
import { SponsorSearchOptions } from '../../interface/enrollment/sponsor-search-options.interface';
import { SponsorSearchValue } from '../../interface/enrollment/sponsor-search-value.interface';
import { CustomerService } from '../../services/customer.service';
import { EnrollmentMessageService } from '../../services/enrollment-message.service';
import { SponsorConfigService } from '../../services/sponsor-config.service';
import { SponsorService } from '../../services/sponsor.service';


@Component({
  selector: 'app-sponsor-search',
  templateUrl: '../../templates/template1/views/enrollment/sponsor-search.component.html',
  styleUrls: ['../../templates/template1/themes/default/css/guest-personal-info.component.less']
})

export class SponsorSearchComponent implements OnInit, OnDestroy {
  // tslint:disable-next-line:no-input-rename
  @Input('selectedSponsor') selectedSponsor: SponsorInformation;
  @Input() storeInfo;
  @Input() sponsorConfig;
  @Input() rebindSponsorOptions: RebindSponsorData;
  @Input() countryCode: string;
  @Input() participatingCountry;
  @Input('selectedOrderType') selectedOrderType: OrderType;
  // tslint:disable-next-line:no-output-rename
  @Output('selectedSponsorInfo') selectedSponsorInfo = new EventEmitter<any>();
  // tslint:disable-next-line:no-output-rename
  @Output('rebindSponsor') rebindSponsor = new EventEmitter<any>();
  isRepSiteSponsor = false;
  isSponsorLoading = false;
  sponsorSearchOptions: SponsorSearchOptions[];
  sponsorSearchWizardType = SponsorWizardSearchType;
  sponsorSearchOptionType = SponsorSearchOption;
  sponsorWizard: SponsorWizardSearchType;
  browserCountry: Country;
  selectedCountryISO: string;
  selectedSponsorCountry: number;
  setSuggestZipCode: string;
  selectedZipCode: string;
  selectedCity: string;
  setLanguagesByCountry: Language[];
  setSuggestLanguage: string;
  suggestSponsorForm: FormGroup;
  zipCodePatterns: ZipCodePattern[];
  zipPattern = '^[0-9]{5}(-[0-9]{4})?$';
  sponsorFields: SponsorSearchValue[];
  isSponsorSelected = true;
  showAuthorizedFBO = true;
  referringFboId: string;
  firstName: string;
  lastName: string;
  city: string;
  searchBySponsorError = false;
  sponsorNotFound = false;
  sponsorErrorMessage: string;
  noSponsorFound = false;
  addressId?:number;
  isFboNameEnabled = false;
  isFboIdEnabled = false;
  refFboIdErrorMessage: string;
  isSponsorEligible = true;
  searchByIDOrNameSponsors: SponsorInformation[];
  searchBySuggestSponsors: SponsorInformation[];
  noSuggestSponsorFound = false;
  suggestSponsorFound = false;
  isAutoAssign = false;
  selectedSponsorState: number;
  formSubmitted = false;
  cityOrZipcodeerrMsg = false;
  isReferrerEligible = true;
  referrerSponsorNotFound = false;
  filteredTitanCountries: Country[];
  filteredNonTitanCountries: Country[];
  memberMetadataModels: any[];
  isContactSponsorSelected: boolean;
  contactSponsorEmail: boolean;
  contactSponsorPhone: boolean;
  sponsorAssignedOptionId: number;
  memberCommunicationPreferences: MemberCommunicationPreference = {
    email: false,
    phone: false
  };
  showStates = true;
  addressLine1: string;
  isFirstNameError: boolean;
  isLastNameError: boolean;
  notifyMeCheckBoxControl = new FormControl('');
  isLoggedInSponsorInfo = false;
  sponsorSearchCriteria = SponsorSearchCriteria;
  sponsorPollCount = 0;
  isoCountryCode = '';
  languageCode = '';
  userInfo: Member;
  sponsorMaxPollCount = environment.longPollCount;
  pollStarted = false;
  searchOptionChanged = false;
  isSponsorOptional = false;
  orderType =  OrderType;
  countries: any;
  states: State[];
  countryId: number;
  setSuggestState: number;
  sponsorInfoNotSelectedErr = false;
  participatingCountrySubscription: Subscription;
  storeSubscription: Subscription;
  selectedState: number;
  defaultStateId = 0;
  cityFieldRequired = false;

  constructor(
    private _sponsorService: SponsorService,
    private _formBuilder: FormBuilder,
    private _cacheService: CacheService,
    private _enrollmentMessageService: EnrollmentMessageService,
    private _customerService: CustomerService,
    private _sponsorConfigService: SponsorConfigService
  ) {
    this.participatingCountrySelected();
  }

  ngOnInit() {
    let isLoadSponsorOptions = false;
    if (this.storeInfo) {
      if (this.selectedCountryISO !== this.storeInfo.homeIsocodeThree) {
        isLoadSponsorOptions = true;
      }
      this.selectedCountryISO = this.storeInfo.homeIsocodeThree;
    } else {
      this.selectedCountryISO = 'USA';
    }
    this.sponsorConfig = this._sponsorConfigService.getSettings(this.selectedCountryISO);
    this.getStoreConfig();
    if (isLoadSponsorOptions) {      
      this.getSponsorSearchOptions();
    }
    this.isSponsorOptional = this.sponsorConfig && this.sponsorConfig.loadSponsorWizardInGuestFlow;
    this.isSponsorInfoSelected();
  }

  getStoreConfig(): void {
    this.getCountriesLookup();
    this.storeSubscription = this._enrollmentMessageService.getStoreInfo().subscribe((response: StoreConfig) => {
      if (response) {
        this.storeInfo = response;
        this.selectedCountryISO = this.storeInfo.homeIsocodeThree;
        this.sponsorConfig = this._sponsorConfigService.getSettings(this.selectedCountryISO);
        this.selectedSponsorCountry = this.storeInfo.countryId ? this.storeInfo.countryId : this.browserCountry.countryId;
        this.countryId=this.storeInfo.countryId;
        this.getCountriesLookup();
        this.getSponsorSearchOptions();
      } else {
        this.resetVariable(SponsorWizardSearchType.SearchByIDontHaveSponsor);
      }
    });
    // this.validateParticipatingCountry();
  }

  validateParticipatingCountry(): void {
    if (this.participatingCountry) {
      this.selectedSponsorCountry = this.participatingCountry.countryId;
      this.onCountryChange(this.selectedSponsorCountry);
    } else {
      this.selectedSponsorCountry = this.storeInfo && this.storeInfo.countryId ? this.storeInfo.countryId
      : this.browserCountry.countryId;
    }
    this.countryId = this.selectedSponsorCountry;
  }

  /**
* @description this method will load config info based on country
* @private
* @memberof SponsorSelectionComponentNew
*/
  private loadSponsorConfigInfo(storeInfo?: any): void {    
    if (storeInfo) {
      this.getLanguagesLookup(storeInfo);
    } else {
      this._sponsorService.getStoreByCountryCode(this.selectedCountryISO).subscribe((res: StoreConfig) => {
        if(res) {
          this.getLanguagesLookup(res);
        }
      });
    }
    this.getZipCodePatterns();
    this.setSuggestSponsorPreference();
  }

  /**
  * @description this method
  * is used to set default country and zipCode
  * based on mailing address
  * @date 2018-07-20
  * @memberof SponserSelectionComponent
  */
 setSuggestSponsorPreference(): void {
  this._enrollmentMessageService.getSponsorPreference()
    .subscribe((liveFormAddress: Address) => {
      if (liveFormAddress) {
        this.selectedZipCode = liveFormAddress.zip;
        this.selectedCity = liveFormAddress.city;
        this.city = this.selectedCity;
        this.setSuggestZipCode = this.selectedZipCode;
        this.addressLine1 = liveFormAddress.addressLine1;
        this.selectedState = liveFormAddress.stateId;
        this.setSuggestState = this.selectedState;
        this.addressId=liveFormAddress.addressId?liveFormAddress.addressId:this.addressId;
        this.buildSuggestSponsorForm();
      }
    });
}

  /**
  * suggestSponsor method used to prepare request for Suggest a Sponsor
  * @param  form
  * @param  {boolean} isValid
  * @returns void
  */
  suggestSponsor(form, isValid: boolean): void {
    let languageId;
    if (!form.value.sponsorZipcode &&
      (this.sponsorConfig && !this.sponsorConfig.isSponsorSearchByArea)) {
      this.cityOrZipcodeerrMsg = true;
      return;
    }
    if (!form.value.sponsorCity &&
      (this.sponsorConfig && this.sponsorConfig.sponsorCityFieldRequired)) {
      this.cityFieldRequired = true;
      return;
    } else {
      this.cityFieldRequired = false;
    }
    if (this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea && !form.value.sponsorState) {
      this.cityOrZipcodeerrMsg = true;
      return;
    }
    if (form.value.sponsorLanguage && this.setLanguagesByCountry) {
      languageId = this.setLanguagesByCountry.find(x => x.languageName.toUpperCase()
        === form.value.sponsorLanguage.toUpperCase()).languageId;
    }
    let addressLine1 = '';
    if (this.addressLine1
      && this.setSuggestZipCode && form.value.sponsorZipcode
      && (this.setSuggestZipCode === form.value.sponsorZipcode)) {
      addressLine1 = this.addressLine1;
    }
    let suggestedAddressId=null;
    if (this.sponsorConfig && this.sponsorConfig.addressIdForSponsorSearch) {
      if (this.setSuggestZipCode && form.value.sponsorZipcode && this.setSuggestZipCode === form.value.sponsorZipcode) {
        suggestedAddressId = this.addressId ? this.addressId : 0;
      }else if(this.setSuggestZipCode && form.value.sponsorZipcode && this.setSuggestZipCode != form.value.sponsorZipcode){
        suggestedAddressId=0;
      }
    }
    const country: Country = this.countries.find((x: Country) =>
            (x.countryId) === +this.countryId);
    const sponsorSearchRequest: SponsorSearchRequest = {
      UserName: '',
      Email: '',
      FirstName: '',
      LastName: '',
      CountryId: this.countryId ? this.countryId.toString() : '',
      CountryCode: country ? country.isocodeThree : this.selectedCountryISO,
      AddressLine1: addressLine1,
      PreferenceValue: languageId,
      addressId:suggestedAddressId,
      PostalCode: form.value.sponsorZipcode ? form.value.sponsorZipcode : '',
      StateId: this.suggestSponsorForm.controls['sponsorState'].value ?
      this.suggestSponsorForm.controls['sponsorState'].value.toString() : '',
      City: form.value.sponsorCity ? form.value.sponsorCity : '',
      Option: this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea ?
      SponsorSearchOption.SearchByArea : SponsorSearchOption.SearchByIDontHaveSponsor,
      EnableLongPoll: environment.enableLongPoll,
      Store:  country ? country.isocodeThree : this.selectedCountryISO
    };
    if(!this.sponsorConfig.participatingCountryForSponsorSerach) {
      sponsorSearchRequest.ParticipatingCountryCode = '';
    }
    if (!this.formSubmitted) {
      this.formSubmitted = true;
      this.markControlsAsTouched(this.suggestSponsorForm);
    }
    if (isValid || !form.value.sponsorZipcode) {
      this.getSponsorInformation(sponsorSearchRequest, SponsorSearchOption.SearchByIDontHaveSponsor);
    }
  }
  /**
   * Mark all the elements as touched to show validation messages
   * @param  {FormGroup} form
   * @returns void
   */
  markControlsAsTouched(form: FormGroup): void {
    if (form) {
      Object.keys(form.controls).forEach(function (key) {
        form.controls[key].markAsTouched();
      });
    }
  }
  /**
     * Getting Languages by Country
     * getLanguagesLookup
     * @param {string} selectedCountryISO
     * @memberof SponsorSelectionComponentNew
     */
  getLanguagesLookup(storeInfo: any): void {    
      this.setLanguagesByCountry = storeInfo.languages;

      if (this.storeInfo && this.storeInfo.languages) {
        this.languageCode = this.storeInfo.languages.find(x => x.default === true).cultureName;
      }
      this.setSuggestLanguage = this.setLanguagesByCountry.find(x => x.cultureName.toUpperCase()
        === this.languageCode.toUpperCase()).languageName;
      this.buildSuggestSponsorForm();  
  }

  /**
     *  Get zipcode patterns
     *  getZipCodePatterns
     * @memberof SponsorSelectionComponentNew
     */
  getZipCodePatterns() {
    this._sponsorService.getZipCodePatterns().subscribe((response: ZipCodePattern[]) => {
      const country: Country = this.countries.find((x: Country) =>
            (x.countryId) === +this.countryId);
      const countryCode = country && this.participatingCountry ? country.isocodeThree : this.selectedCountryISO;
      this.zipCodePatterns = response;
      const pattern = this.zipCodePatterns.filter(x => x.isoCodeThree
        === countryCode)[0];
      this.zipPattern = pattern ? pattern.zipPattern : null;
    });
  }

  /**
   * @description method to get sponsor search options
   * @memberof SponsorSelectionComponentNew
   */
  getSponsorSearchOptions(): void {
    const operatingCountry = this.storeInfo && this.storeInfo.operatingCountry || IsoCodeThree.USA;
    this._sponsorService
      .sponsorOptions(operatingCountry)
      .subscribe((response: SponsorInformation) => {
        if (response) {
          this.sponsorSearchOptions = response.sponsorSearchOptions;
          let sponsorId = '';
          if (this.sponsorConfig && this.sponsorConfig.loadSponsorWizardInGuestFlow
             && (this.selectedOrderType === OrderType.NEW_GUEST_RETAIL || this.selectedOrderType === OrderType.NEW_FPC)) {
               if(this.sponsorConfig.displayIDontHaveSponsorGuestSection && this.selectedOrderType === OrderType.NEW_GUEST_RETAIL) {
                this.sponsorWizard = SponsorWizardSearchType.SearchByIDontHaveSponsor;
               } else {
                this.sponsorWizard = SponsorWizardSearchType.SearchByIKnowSponsor;
               }
          } else {
            this.sponsorWizard = SponsorWizardSearchType.SearchByIKnowSponsor;
          }
          const rebindSponsorData: RebindSponsorData = this.rebindSponsorOptions;
          if (this.selectedSponsor) {
            sponsorId = this.selectedSponsor.sponsorId ?
            this.selectedSponsor.sponsorId : '';
          }
          if (sponsorId && rebindSponsorData && !rebindSponsorData.isDefaultSponsorSelected && rebindSponsorData.sponsorWizardType) {
            this.rebindSponsorData(rebindSponsorData);
          } else if (this.userInfo && this.userInfo.sponsorId) {
            this.getMemberCommunication();
          } else {
            this.setSponsorWizard(this.sponsorWizard);
          }
        }
      });
  }

  /**
  * addig sponsor search for guest 
  */
 prepareDontHaveSponsorGuestSection():SponsorSearchOptions{
  const sponsorSearchOptions: SponsorSearchOptions = {
    id: SponsorSearchOption.DonthaveSponsorGuest,
    option: SponsorWizardSearchType.DonthaveSponsorGuest,
    autoAssign: false,
    sponsorSearchValues: [],
  };
  return sponsorSearchOptions;
   
}

  /**
  * preload suggest sponsor information
  * @memberof SponsorSelectionComponentNew
  */
  preloadSponsorInformation(rebindSponsorData: RebindSponsorData, sponsorInfo: SponsorInformation): void {
    this.selectedSponsor = sponsorInfo;
    const sponsors: SponsorInformation[] = [];
    sponsors.push(this.selectedSponsor);
    if (rebindSponsorData.sponsorWizardType === SponsorWizardSearchType.SearchByIDontHaveSponsor) {
      this.searchBySuggestSponsors = sponsors;
      this.suggestSponsorFound = true;
    }
    this.setSponsor(this.selectedSponsor);
    this.setSponsorInformation();
  }

  /**
     *get member preferences and bind with Preferences Data
     *
     * @memberof CommunicationPreferencesComponent
     */
  getMemberCommunication(): void {
    const memberCommunicationPreferences = {
      email: false,
      phone: false
    };
    this._sponsorService.getMemberCommunicationPreferences(this.userInfo.memberId).subscribe(
      (response: any) => {
        if (response) {
          if (response.memberPreferenceModels) {
            const email = response.memberPreferenceModels.
              find(item => item.preferenceId === MemberPreferenceType.Email &&
                +item.preferenceValue === MemeberCommunicationPreferenceValue.YES);
            const phone = response.memberPreferenceModels.
              find(item => item.preferenceId === MemberPreferenceType.Phone &&
                +item.preferenceValue === MemeberCommunicationPreferenceValue.YES);
            const notifyPreferences = response.memberPreferenceModels.
              find(item => item.preferenceId === MemberPreferenceType.NotifyMe &&
                +item.preferenceValue === MemeberCommunicationPreferenceValue.YES);
            if (email) {
              memberCommunicationPreferences.email = true;
            }
            if (phone) {
              memberCommunicationPreferences.phone = true;
            }
            this.rebindMemberPreferences(memberCommunicationPreferences);
            if (notifyPreferences) {
              this.notifyMeCheckBoxControl.setValue(true);
            }
          }
        }
      });
  }

  /**
* @description binding member preferences
* @param {MemberCommunicationPreference} memberCommunicationPreferences
* @memberof SponsorSelectionComponentNew
*/
  rebindMemberPreferences(memberCommunicationPreferences: MemberCommunicationPreference): void {
    if (memberCommunicationPreferences.email) {
      this.contactSponsorEmail = memberCommunicationPreferences.email;
      this.isContactSponsorSelected = true;
    }
    if (memberCommunicationPreferences.phone) {
      this.contactSponsorPhone = memberCommunicationPreferences.phone;
      this.isContactSponsorSelected = true;
    }
    this.memberCommunicationPreferences = {
      email: this.contactSponsorEmail,
      phone: false
    };
  }

  /**
   * @description this method will rebind sponsor information
   * @param {RebindSponsorData} rebindSponsorData
   * @memberof SponsorSelectionComponentNew
   */
  rebindSponsorData(rebindSponsorData: RebindSponsorData) {

    if (rebindSponsorData.sponsorWizardType) {
      if (rebindSponsorData.sponsorWizardType === SponsorWizardSearchType.SearchByIKnowSponsor) {
        this.resetVariable(SponsorWizardSearchType.SearchByIKnowSponsor);
        this.setSponsorWizard(rebindSponsorData.sponsorWizardType);
        this.firstName = rebindSponsorData.firstName ? rebindSponsorData.firstName : '';
        this.lastName = rebindSponsorData.lastName ? rebindSponsorData.lastName : '';
        this.selectedSponsorCountry = rebindSponsorData.country ? rebindSponsorData.country : 0;
        this.getStatesLookup(this.selectedSponsorCountry, false);
        this.selectedSponsorState = rebindSponsorData.state ? rebindSponsorData.state : 0;
        this.referringFboId = rebindSponsorData.sponsorId ? rebindSponsorData.sponsorId : '';
        if (this.referringFboId) {
          this.searchSponsorWizardByFboId();
          this.disableFboIdOrName();
        } else {
          this.searchSponsorByName(this.firstName, this.lastName,
            this.selectedSponsorCountry, this.selectedSponsorState);
          this.disableFboIdOrName();
        }
        if (rebindSponsorData.selectedSponsor) {
          this.selectedSponsor = rebindSponsorData.selectedSponsor;
          this.preloadSponsorInformation(rebindSponsorData, this.selectedSponsor);
        }
      } else if (rebindSponsorData.sponsorWizardType === SponsorWizardSearchType.SearchByIDontHaveSponsor) {
        this.setSponsorWizard(rebindSponsorData.sponsorWizardType);
        this.city = rebindSponsorData.city ? rebindSponsorData.city : '';
        this.setSuggestZipCode = rebindSponsorData.zipCode ? rebindSponsorData.zipCode : '';
        this.setSuggestLanguage = rebindSponsorData.language ? rebindSponsorData.language : '';
        this.setSuggestState = rebindSponsorData.state ? rebindSponsorData.state : 0;
        this.buildSuggestSponsorForm();
        if (this.selectedSponsor) {
          this.preloadSponsorInformation(rebindSponsorData, this.selectedSponsor);
        } else {
          this.suggestSponsor(this.suggestSponsorForm, true);
        }
      }

    }
  }

  /**
  * setSponsorWizard method used to check or uncheck sponsor search options based on selected value
  * @param  {string} selectedSponsor
  * @returns void
  */
  setSponsorWizard(selectedSponsor: SponsorWizardSearchType, removeDefaultSponsor?: boolean): void {

    let filteredSponsorOption = [];
    this.isFirstNameError = false;
    this.isLastNameError = false;
    this.sponsorWizard = selectedSponsor;
    if (selectedSponsor === this.sponsorSearchWizardType.SearchByIKnowSponsor) {
      filteredSponsorOption = this.sponsorSearchOptions
        .filter(x => x.id === this.sponsorSearchOptionType.SearchByIKnowSponsor);
      const sponsorFieldByName = this.sponsorSearchOptions
        .filter(x => x.id === this.sponsorSearchOptionType.SearchByFBOName);
      this.sponsorFields = filteredSponsorOption[0].sponsorSearchValues
        .concat(sponsorFieldByName[0].sponsorSearchValues);

    } else {
      filteredSponsorOption = this
        .sponsorSearchOptions.filter(x => x.id
          === this.sponsorSearchOptionType.SearchByIDontHaveSponsor);
          if (filteredSponsorOption && filteredSponsorOption.length) {
            this.sponsorFields = filteredSponsorOption[0].sponsorSearchValues;
          }
    }
  }

  /**
     * @description
     * @param {SponsorWizardSearchType} selectedSponsor
     * @memberof SponsorSelectionComponentNew
     */
  resetVariable(selectedSponsor: SponsorWizardSearchType): void {
    this.noSponsorFound = false;
    this.searchBySuggestSponsors = null;
    this.searchByIDOrNameSponsors = null;
    this.cityOrZipcodeerrMsg = false;
    this.cityFieldRequired = false;
    this.selectedSponsor = null;
    this.sponsorInfoNotSelectedErr = false;
    this.selectedSponsorInfo.emit(this.selectedSponsor);
    this.sponsorWizard = selectedSponsor;
    this.getStatesByCountryId();
    this.selectedSponsorState = 0;
    if (selectedSponsor === this.sponsorSearchWizardType.SearchByIKnowSponsor) {
      this.firstName = '';
      this.lastName = '';
      this.referringFboId = '';
      // this.validateParticipatingCountry();
      // this.selectedSponsorState = 0;
      this.searchBySponsorError = false;
      this.disableFboIdOrName();
    } else if (selectedSponsor === this.sponsorSearchWizardType.SearchByIDontHaveSponsor) {
      this.city = this.selectedCity;
      this.setSuggestZipCode = this.selectedZipCode;
      this.buildSuggestSponsorForm();
    }
    this.setSelectedSponsorInformation();
    if (this.pollStarted) {
      this.sponsorPollCount = this.sponsorMaxPollCount;
      this.isSponsorLoading = false;
      this.searchOptionChanged = true;
      this.pollStarted = false;
    }
  }

  /**
* Suggest Sponsor Form
* @returns void
*/
  buildSuggestSponsorForm(): void {

    this.suggestSponsorForm = this._formBuilder.group(
      {
        sponsorZipcode: [this.setSuggestZipCode ? this.setSuggestZipCode : '', [ Validators.required]],
        sponsorLanguage: [this.setSuggestLanguage ? this.setSuggestLanguage : '', []],
        sponsorState: [this.setSuggestState ? this.setSuggestState : this.defaultStateId, []],
        sponsorCountry: [this.countryId ? this.countryId : '', []],
        sponsorCity: [this.city ? this.city : ''],
      });
      if(this.sponsorConfig && this.sponsorConfig.sponsorCityFieldRequired) {
        this.suggestSponsorForm.controls['sponsorCity'].setValidators([Validators.required]);
        this.suggestSponsorForm.controls['sponsorCity'].updateValueAndValidity();
      }
  }

  get sponsorZipcode() {
    return this.suggestSponsorForm.get('sponsorZipcode');
  }
  /**
* @description this method will enable diable the textbox
* based on selction
* @memberof SponsorSelectionComponentNew
*/
  disableFboIdOrName(isFboNameSearch?: boolean): void {
    this.sponsorNotFound = false;
    this.isSponsorEligible = true;
    this.searchBySponsorError = false;
    this.searchByIDOrNameSponsors = null;
    this.selectedSponsor = null;
    if (this.referringFboId && !isFboNameSearch) {
      this.firstName = '';
      this.lastName = '';
      this.isFboNameEnabled = true;
      this.isFboIdEnabled = false;
    } else if (this.firstName || this.lastName) {
      this.referringFboId = '';
      this.isFboNameEnabled = false;
      this.isFboIdEnabled = true;
      if (this.firstName) {
        this.firstName = this.firstName.trim();
        this.isFirstNameError = false;
      }
      if (this.lastName) {
        this.lastName = this.lastName.trim();
        this.isLastNameError = false;
      }
    } else {
      this.isFboNameEnabled = false;
      this.isFboIdEnabled = false;
    }
  }

  /**
   * searchSponsorByName method used to prepare request for Search by Name
   * @param  {string} firstName
   * @param  {string} lastName
   * @param  {string} countryName
   * @returns void
   */
  searchSponsorByName(firstName: string, lastName: string, countryId: number, stateId: number): void {
    if (!this.isSponsorLoading) {
      if (this.referringFboId) {
        this.searchSponsorWizardByFboId();
      } else {
        if (!firstName || !lastName) {
          this.searchBySponsorError = true;
          this.validateSearchByName(firstName, lastName);
          this.searchByIDOrNameSponsors = null;
          this.sponsorNotFound = false;
          this.noSponsorFound = false;
          this.selectedSponsorInfo.emit(null);
        } else {
          this.searchBySponsorError = false;
          this.sponsorNotFound = false;
          const country: Country = this.countries.find((x: Country) =>
            (x.countryId) === +countryId);
          this.sponsorErrorMessage = '';
          if (firstName.trim() === '' && lastName.trim() === '') {
            this.noSponsorFound = true;
            return;
          }
          const sponsorSearchRequest: SponsorSearchRequest = {
            UserName: '',
            Email: '',
            FirstName: firstName ? firstName.trim() : '',
            LastName: lastName ? lastName.trim() : '',
            CountryId: country ? country.countryId.toString() : '',
            PreferenceValue: '',
            PostalCode: '',
            StateId: stateId && stateId > 0 ? stateId.toString() : '',
            City: '',
            Option: SponsorSearchOption.SearchByFBOName,
            EnableLongPoll: environment.enableLongPoll,
            Store: ''

          };
          this.getSponsorInformation(sponsorSearchRequest, SponsorSearchOption.SearchByIKnowSponsor);
        }
      }
    }
  }

  /**
  * searchSponsorWizardByFboId used to prepare request for Search By FBO ID or Email
  * @param  {string} FboId?
  * @returns void
  */
  searchSponsorWizardByFboId(fboId?: string, error?: any): void {
    if (!error) {
      fboId = fboId ? fboId : this.referringFboId;
      if (!fboId) {
        this.refFboIdErrorMessage = 'Enter Sponsor ID / Email';
        return;
      }
      this.searchBySponsorError = false;
      fboId = fboId.indexOf('@') > -1 ? fboId : fboId.split('-').join('');
      const sponsorSearchRequest: SponsorSearchRequest = {
        UserName: fboId.indexOf('@') > -1 ? '' : fboId.trim(),
        Email: fboId.indexOf('@') > -1 ? fboId.trim() : '',
        FirstName: '',
        LastName: '',
        CountryId: '',
        PreferenceValue: '',
        PostalCode: '',
        StateId: '',
        City: '',
        Option: SponsorSearchOption.SearchByIKnowSponsor,
        EnableLongPoll: environment.enableLongPoll,
        Store: ''
      };
      if (sponsorSearchRequest && sponsorSearchRequest.UserName && sponsorSearchRequest.UserName.length !== 12) {
        this.sponsorNotFound = true;
        return;
      }
      this.getSponsorInformation(sponsorSearchRequest, SponsorSearchOption.SearchByIKnowSponsor);
    }
  }

  /**
  * focus to sugeest sponsor section
  */
  focusOnSuggestSponsor(): void {
    const suggestSponsorElement = document.getElementById('suggestSponsor');
    if (suggestSponsorElement) {
      suggestSponsorElement.focus();
    }
  }

  /**
  * getSponsorInformation used to fetch sponsors from service
  * @param  sponsorSearchRequest
  * @param  {number} option?
  * @returns void
  */
  getSponsorInformation(sponsorSearchRequest: SponsorSearchRequest, searchOption?: number): void {
    this.pollStarted = true;
    this.searchOptionChanged = false;
    this.isSponsorLoading = true;
    this.resetValidationMessage();
    this.sponsorPollCount = 0;
    sponsorSearchRequest.Store = this.countryCode;
    this._sponsorService
      .searchSponsors(sponsorSearchRequest,this.selectedOrderType)
      .subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
        if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
          this.processSearchSponsorResponse(sponsorSearchResponse, searchOption);
        } else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
          sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
            setTimeout(() => {
              this.searchSponsorByPolling(sponsorSearchResponse, searchOption);
            }, 2000);          
        } else {
          this.searchSponsorErrorResponse();
        }
      }, (error) => {
        this.searchSponsorErrorResponse();
      });
  }

  /**
   * @description we will load sponsor by pooling mechanism
   * @private
   * @param {SponsorSearchRequest} sponsorSearchRequest
   * @param {number} [searchOption]
   * @memberof SponsorSelectionComponentNew
   */
  private searchSponsorByPolling(
    searchResponse: SponsorSearchResponse, searchOption?: number): void {
    this._sponsorService
      .getSearchSponsorsByUUID(searchResponse)
      .subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
        if (sponsorSearchResponse) {
          if (this.sponsorPollCount < this.sponsorMaxPollCount) {
            this.sponsorPollCount = this.sponsorPollCount + 1;
            if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
              this.processSearchSponsorResponse(sponsorSearchResponse, searchOption);
            } else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
              sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                setTimeout(() => {
                  this.searchSponsorByPolling(sponsorSearchResponse, searchOption);
                }, 2000);
            } else {
              this.searchSponsorErrorResponse();
            }
          } else {
            this.searchSponsorErrorResponse();
          }
        }
      }, (error) => {
        this.searchSponsorErrorResponse();
      });
  }

  /**
   * @description this method will load when we got error in
   * sponsor search response
   * @private
   * @memberof SponsorSelectionComponentNew
   */
  private searchSponsorErrorResponse(): void {
    this.isSponsorLoading = false;
    if (this.isRepSiteSponsor) {
      this.referrerSponsorNotFound = true;
    } else if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIKnowSponsor && !this.searchOptionChanged) {
      this.sponsorNotFound = true;
      this.searchByIDOrNameSponsors = null;
      if (!this.referringFboId) {
        this.noSponsorFound = true;
      }
    } else if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIDontHaveSponsor && !this.searchOptionChanged) {
      this.noSuggestSponsorFound = true;
      this.searchBySuggestSponsors = null;
    }
  }

  /**
  * @description this method will process the search sponsor response
  * @private
  * @param {SponsorSearchResponse} sponsorSearchResponse
  * @param {number} [searchOption]
  * @returns {void}
  * @memberof SponsorSelectionComponentNew
  */
  private processSearchSponsorResponse(sponsorSearchResponse: SponsorSearchResponse,
    searchOption?: number): void {
    this.isSponsorLoading = false;
    if (sponsorSearchResponse.sponsorSearchResultModels
      && sponsorSearchResponse.sponsorSearchResultModels.length > 0) {
      sponsorSearchResponse.sponsorSearchResultModels =
        sponsorSearchResponse.sponsorSearchResultModels.map(sponsorModel => {
          sponsorModel.uuid = sponsorSearchResponse.uuid;
          return sponsorModel;
        });
      if (!this.isRepSiteSponsor) {
        const sponsorResponse = sponsorSearchResponse.sponsorSearchResultModels;
        if (sponsorResponse.length === 1 && sponsorResponse.length > sponsorSearchResponse.sponsorSearchResultModels.length) {
          this.isSponsorEligible = false;
          this.noSponsorFound = false;
          this.referrerSponsorNotFound = false;
          if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIDontHaveSponsor) {
            this.searchBySuggestSponsors = null;
          } else {
            this.searchByIDOrNameSponsors = null;
          }
        } else {
          this.preSelectSponsorBasedOnOption(sponsorSearchResponse, searchOption, true);
        }
      } else if (!(sponsorSearchResponse.sponsorSearchResultModels 
        && sponsorSearchResponse.sponsorSearchResultModels.length > 0)) {
        this.isReferrerEligible = false;
        this.referrerSponsorNotFound = false;
      } else {
        this.isReferrerEligible = true;
        this.referrerSponsorNotFound = false;
        this.prepareMemberMetadataModels(SponsorSearchOption.SearchByIKnowSponsor);
        this.setSponsor(sponsorSearchResponse.sponsorSearchResultModels[0]);
      }
    }
  }
  /**
   * @description
   * @param {SponsorInformation} sponsor
   * @param {number} [index]
   * @memberof SponsorSelectionComponentNew
   */
  setSponsor(sponsor: SponsorInformation, index?: number): void {
    sponsor.address = this._sponsorService.mapAddressModel(sponsor);
    this.sponsorInfoNotSelectedErr = false;
    this.selectedSponsor = sponsor;
    this.setSelectedSponsorInformation();
    this.setSponsorInformation();
  }

  /**
   * assignSponsor method used to set sponsors based on selected option
   * @param response
   * @param  {number} option?
   * @returns void
   */
  preSelectSponsorBasedOnOption(sponsorSearchResponse: SponsorSearchResponse, option?: number, isSearch?: boolean): void {
    if (sponsorSearchResponse && sponsorSearchResponse.sponsorSearchResultModels && sponsorSearchResponse.isSuccess) {
      switch (this.sponsorWizard) {
        case this.sponsorSearchWizardType.SearchByIKnowSponsor:
          this.searchByIKnowSponsor(sponsorSearchResponse);
          break;
        case this.sponsorSearchWizardType.SearchByIDontHaveSponsor:
          this.searchByIDontHaveSponsor(sponsorSearchResponse);
          break;
        default:
          break;
      }
      if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIDontHaveSponsor) {
        this.suggestSponsorFound = true;
      }
      if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByFBOName) {
        if (this.searchByIDOrNameSponsors && this.searchByIDOrNameSponsors.length > 0) {
          this.noSponsorFound = false;
        } else {
          this.noSponsorFound = true;
        }
      }
    } else if (this.sponsorWizard ===
      this.sponsorSearchWizardType.SearchByFBOName
      && sponsorSearchResponse && !sponsorSearchResponse.isSuccess) {
      this.noSponsorFound = true;
      this.sponsorErrorMessage = sponsorSearchResponse.responseMessage;
    } else if (this.sponsorWizard ===
      this.sponsorSearchWizardType.SearchByIKnowSponsor
      && sponsorSearchResponse && !sponsorSearchResponse.isSuccess) {
      this.sponsorNotFound = true;
      this.sponsorErrorMessage = sponsorSearchResponse.responseMessage;
    } else if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIDontHaveSponsor) {
      this.noSuggestSponsorFound = true;
      this.searchBySuggestSponsors = null;
    }
    if (!sponsorSearchResponse.sponsorSearchResultModels) {
      this.noSponsorFound = true;
    }
  }
  /**
    * @description this method will excecute when the switch case
    * value is searchByIKnowSponsor
    * @private
    * @param {SponsorSearchResponse} sponsorSearchResponse
    * @returns {void}
    * @memberof SponsorSelectionComponentNew
    */
  private searchByIKnowSponsor(sponsorSearchResponse: SponsorSearchResponse): void {
    this.prepareMemberMetadataModels(SponsorSearchOption.SearchByIKnowSponsor);
    if (sponsorSearchResponse.sponsorSearchResultModels.length < 1) {
      this.isSponsorEligible = false;
      this.noSponsorFound = true;
      return;
    } else {
      this.isSponsorEligible = true;
      this.noSponsorFound = false;
      this.searchByIDOrNameSponsors = sponsorSearchResponse.sponsorSearchResultModels;
      if (sponsorSearchResponse.sponsorSearchResultModels.length === 1) {
        const sponsorMapModel = this.searchByIDOrNameSponsors[0];
        sponsorMapModel.address = this._sponsorService.mapAddressModel(sponsorMapModel);
        this.selectedSponsor = sponsorMapModel;
        this.searchByIDOrNameSponsors[0]['isAutoSelect'] = true;
        this.setSelectedSponsorInformation();
        this.setSponsorInformation();
      } else {
        this.setSelectedSponsorInformation();
        if (this.selectedSponsor) {
          this.searchByIDOrNameSponsors.forEach((sponsor: any) => {
            if (this.selectedSponsor.sponsorId === sponsor.sponsorId) {
              sponsor['isAutoSelect'] = true;
            }
          });
        }
      }
    }
  }
  /** set selected sponsor from search suggestion to enrollement process
    */
  setSponsorInformation(): void {
    if (!this.selectedSponsor) {
      this.isSponsorSelected = false;
      this.sponsorNotFound = false;
      this.searchBySponsorError = false;
      this.noSponsorFound = false;
      this.cityOrZipcodeerrMsg = false;
      this.cityFieldRequired = false;
    } else {
      this.isSponsorSelected = true;
      this.showAuthorizedFBO = true;
      this.selectedSponsor.memberMetadataModels = this.memberMetadataModels;
      this.selectedSponsor.memberCommunicationPreferences = this.memberCommunicationPreferences;
      this.selectedSponsor.sponsorAssignedOptionId = this.sponsorAssignedOptionId;
      this.selectedSponsor.notifyMeAboutUpdates = this.notifyMeCheckBoxControl.value;
       this.selectedSponsorInfo.emit(this.selectedSponsor);
    }
  }



  /**
  * set selected sponsor information
  * @memberof SponsorSelectionComponentNew
  */
  setSelectedSponsorInformation(): void {
    const sponsorWizard = this.selectedSponsor ? this.sponsorWizard : '';
    const rebindSponsor = {
      sponsorWizardType: sponsorWizard,
      sponsorId: this.referringFboId,
      firstName: this.firstName ? this.firstName : '',
      lastName: this.lastName ? this.lastName : '',
      state: this.selectedSponsorState ? this.selectedSponsorState : 0,
      country: this.selectedSponsorCountry ? this.selectedSponsorCountry : '',
      city: '',
      zipCode: this.suggestSponsorForm ? this.
        suggestSponsorForm.controls['sponsorZipcode'].value : '',
      language: this.suggestSponsorForm ? this.
        suggestSponsorForm.controls['sponsorLanguage'].value : '',
      isDefaultSponsorSelected: this.isLoggedInSponsorInfo,
      selectedSponsor: this.selectedSponsor,
      selectedWizard: this.sponsorWizard
    };
    this.rebindSponsor.emit(rebindSponsor);
  }


  /**
   * @description this method will prepare member
   * metamodels
   * @param {number} option
   * @memberof SponsorSelectionComponentNew
   */
  prepareMemberMetadataModels(option: number): void {
    if (!this.isAutoAssign && this.sponsorSearchOptions) {
      const filteredSponsorOption = this.
        sponsorSearchOptions.filter(x => x.id === option)[0];
      const nameValues = {
        id: filteredSponsorOption.id,
        option: filteredSponsorOption.option,
        sponsorSearchValues: filteredSponsorOption.sponsorSearchValues,
      };
      this.sponsorAssignedOptionId = filteredSponsorOption.id;
      this.memberMetadataModels = [{
        code: 'SponsorSearch',
        name: JSON.stringify(nameValues),
        memberId: null,
        keyValueDesc: ''
      }];
    }
  }


  /**
   * @description this method will excecute when the switch case
   * value is searchByIDontHaveSponsor
   * @private
   * @memberof SponsorSelectionComponentNew
   */
  private searchByIDontHaveSponsor(sponsorSearchResponse: SponsorSearchResponse): void {
    this.prepareMemberMetadataModels(SponsorSearchOption.SearchByIDontHaveSponsor);
    this.noSuggestSponsorFound = false;
    this.suggestSponsorFound = true;
    this.searchBySuggestSponsors = sponsorSearchResponse.sponsorSearchResultModels;
    if (this.searchBySuggestSponsors.length >= 1) {
      const sponsorMapModel = this.searchBySuggestSponsors[0];
      sponsorMapModel.address = this._sponsorService.mapAddressModel(sponsorMapModel);
      this.selectedSponsor = sponsorMapModel;
      this.searchBySuggestSponsors[0]['isAutoSelect'] = true;
      this.setSelectedSponsorInformation();
      this.setSponsorInformation();
    } else {
      this.setSelectedSponsorInformation();
    }
  }

  /**
    * @description
    * @param {string} firstName
    * @param {string} lastName
    * @memberof SponsorSelectionComponentNew
    */
  validateSearchByName(firstName: string, lastName: string) {
    if (!firstName && lastName) {
      this.isFirstNameError = true;
      this.searchBySponsorError = false;
      this.isLastNameError = false;
    } else if (firstName && !lastName) {
      this.isFirstNameError = false;
      this.searchBySponsorError = false;
      this.isLastNameError = true;
    }
  }

  /**
   *  Resetting validation message while searching sponsor info
   *  resetValidationMessage
   * @memberof SponsorSelectionComponentNew
   */
  resetValidationMessage() {
    this.sponsorNotFound = false;
    this.searchBySponsorError = false;
    this.noSponsorFound = false;
    this.isSponsorSelected = true;
    this.cityOrZipcodeerrMsg = false;
    this.cityFieldRequired = false;
    this.selectedSponsor = null;
    this.sponsorInfoNotSelectedErr = false;
    this.deSelectSponsor();
  }

  /**
  * @description UnselectSponsor method used to unselect the sponsor
  * @returns void
  */
  deSelectSponsor(): void {
    this.selectedSponsor = null;
    this.showAuthorizedFBO = false;
    this.selectedSponsorInfo.emit(this.selectedSponsor);
  }
  /**
     * @description method to get countries lookup
     * @memberof AddressNewComponent
     */
  getCountriesLookup() {
    if (this._cacheService.get(CacheKey.COUNTRIES)) {
      this.countries = this._cacheService.get(CacheKey.COUNTRIES);
      this.getFilteredCountries(this.countries);
    } else {
      this._customerService.getCountriesLookup().subscribe((res: Country[]) => {
        if (res && res.length > 0) {
          this.countries = res;
          this._cacheService.set(CacheKey.COUNTRIES, this.countries);
          this.getFilteredCountries(this.countries);
        }
      });
    }
  }
  getFilteredCountries(countries: Country[]) {
    this.filteredTitanCountries = countries.filter(x => x.titanPlatformEnabled === true);
    this.filteredNonTitanCountries = countries.filter(x => x.titanPlatformEnabled === false);
    this.browserCountry = countries.find((x: Country) =>
      (x.isocodeThree).toLowerCase() === this.countryCode.toLowerCase());
    if (this.participatingCountry) {
      this.selectedSponsorCountry = this.participatingCountry.countryId;
    } else {
      this.selectedSponsorCountry = this.storeInfo && this.storeInfo.countryId ? this.storeInfo.countryId : this.browserCountry.countryId;
    }
    this.countryId = this.selectedSponsorCountry;
    const country: Country = countries.find((x: Country) =>
      (x.countryId) === +this.selectedSponsorCountry);
    if (country) {
      this.selectedCountryISO = country.isocodeThree;
      // Get states By Country
      this.getStatesLookup(country.countryId, true);
    }
  }

  /**
     * @description get states by country
     * @memberof AddressNewComponent
     */
  getStatesByCountryId() {
    if (this.participatingCountry && this.participatingCountry.countryId) {
      this.selectedSponsorCountry = this.participatingCountry.countryId;
    } else {
      this.selectedSponsorCountry = this.storeInfo && this.storeInfo.countryId ? this.storeInfo.countryId
        : this.browserCountry.countryId;
    }
    const country = this.countries
      .find((x: Country) => x.countryId === +this.selectedSponsorCountry);
    const hideSponsorStateDropdownCountry = this.sponsorConfig && country && this.sponsorConfig.hideSponsorStateDropdownCountires
      .find(x => x.toLowerCase() === country.isocodeThree.toLowerCase());
    if (country && !hideSponsorStateDropdownCountry && (this.storeInfo.homeIsocodeThree === country.isocodeThree || (this.storeInfo.homeIsocodeThree !== country.isocodeThree && this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea))) {
      this.countryId = country.countryId;
      this._customerService.getStatesByCountryId(this.countryId).subscribe((res: State[]) => {
        this.states = res;
        this.setDefaultStateId(this.states);
      });
      this.showStates = true;
    } else {
      this.showStates = false;
    }
  }

  /**
   * @description On Country change
   * @param {number} event
   * @memberof SponsorSelectionComponentNew
   */
  onCountryChange(event: number): void {
    if (event) {
      const countryId = event;
      this.selectedSponsorState = 0;
      this.getStatesLookup(countryId, false);
    }
  }

  /**
  * trim text elment text
  * @param  {FormGroup} form
  * @returns void
  */
  trimValue(event) {
    const value = event.target.value;
    if (value) {
      event.target.value = value.trim().length === 0 ? value.trim() : value;
    }
  }
  /**
  *  Getting States By country
  *  getStatesLookup
  * @param {number} countryId
  * @memberof SponsorSelectionComponentNew
  */
  getStatesLookup(countryId: number, reloadSponsorConfig: boolean): void {
    const country: Country = this.filteredTitanCountries && this.filteredTitanCountries.find((x: Country) =>
      (x.countryId) === +countryId);
    const hideSponsorStateDropdownCountry = this.sponsorConfig && country && this.sponsorConfig.hideSponsorStateDropdownCountires
    .find(x => x.toLowerCase() === country.isocodeThree.toLowerCase());
    if (country && !hideSponsorStateDropdownCountry) {
      this._customerService.getStoreInfoFromConfig(country.isocodeThree).subscribe((res: any) => {
        const storeInfo = res;
        storeInfo.storeCountryCode = country.isocodeThree;
        if (storeInfo.storeCountryCode === storeInfo.homeIsocodeThree || (storeInfo.storeCountryCode !== storeInfo.homeIsocodeThree && this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea)) {
          this._customerService.getStatesByCountryId(countryId).subscribe((states: State[]) => {
            this.states = states;
            if (reloadSponsorConfig) {
              this.selectedSponsorState = 0;
            }
            this.setDefaultStateId(states);
          });
          this.showStates = true;
        } else {
          this.showStates = false;
        }
        if (reloadSponsorConfig) {
          this.loadSponsorConfigInfo(storeInfo);
        }
      });
    } else {
      this.showStates = false;
      if (reloadSponsorConfig) {
        this.loadSponsorConfigInfo();
        this.selectedSponsorState = 0;
      }
    }
  }
  isSponsorInfoSelected() {
    this._enrollmentMessageService.getIsSponsorInfoSelected().subscribe((response: boolean) => {
      if (!response) {
        this.sponsorInfoNotSelectedErr = true;
      } else {
        this.sponsorInfoNotSelectedErr = false;
      }
    });
  }

  participatingCountrySelected(): void {
    this.participatingCountrySubscription = this._enrollmentMessageService.getParticipatingCountryInfo().subscribe(countryID => {
      if (countryID) {
        this.selectedSponsorCountry = countryID;
        this.onCountryChange(this.selectedSponsorCountry);
      }
    });
  }

  /**
   * @description to set the Defaut State ID
   * @author Akhil
   * @date 2021-08-05
   * @param {State[]} states
   * @memberof SponsorSearchComponent
   */
  setDefaultStateId(states: State[]): void {
    if (states && states.length === 1) {
      this.defaultStateId = states[0].id;
      this.selectedSponsorState = this.defaultStateId
    }
  }

  ngOnDestroy(): void {
    if (this.participatingCountrySubscription) {
      this.participatingCountrySubscription.unsubscribe();
    }
    if (this.storeSubscription) {
      this.storeSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/enrollment/sponsor-search.component.ts